import styles from "./BlurOverlay.module.scss";

export const BlurOverlay = () => <div className={styles.overlay}></div>;
